

export interface ApontamentoEntidadeVm {

    codigo: number,
    codigoEntidade: string,
    usuario: string,
    descricao: string,
    dataHora: Date,
    dataHoraFormatada: string,
    tipo: number,
    tipoDescricao: string
    cgpe:string

}

export function dataAsApontamentoEntidadeVm(data: any): ApontamentoEntidadeVm {
    return data as ApontamentoEntidadeVm;
}


export interface AdicionarApontamentoCommand {
    codigoEntidade: string,
    descricao: string
    cgpe:string
}

export interface RemoverApontamentoCommand {
    codigoApontamento: string
    codigoEntidade: string
    cgpe:string
}

export interface ListarApontamentoQuery {
    codigoEntidade: string
    cgpe:string
}


